<template>
  <div :class="['ar-container', { 'is-vertical': isVertical }]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ArContainer',
  
  componentName: 'ArContainer',

  props: {
    direction: String
  },

  computed: {
    isVertical: function () {
      if (this.direction === 'row') {
        return false;
      } else if (this.direction === 'col') {
        return true;
      }

      return this.$slots && this.$slots.default ? this.$slots.default.some(vnode => {
        const tag = vnode.componentOptions && vnode.componentOptions.tag;
        return tag === 'ar-header' || tag === 'ar-footer' || tag === 'ArHeader' || tag === 'ArFooter';
      })
      : false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/anyUI/container/container.vue